import React from 'react';

import {
  Container,
  FooterContainer,
  FooterGrid,
  CopyrightContainer,
  CopyrightLinksContainer,
  FooterLinks,
  FooterHeading,
  Link,
  CopyRightLink,
  Divider,
  CompanyName,
} from './Footer.styled';

export const Footer = () => (
  <Container>
    <FooterContainer>
      <FooterGrid>
        <div>
          <FooterLinks>
            <FooterHeading>
              <span>Download</span>
            </FooterHeading>
            <Link
              href="https://itunes.apple.com/gb/app/aula-classroom-communication/id909131134?mt=8"
              target="_blank"
              rel="noreferrer"
            >
              iOS app
            </Link>
            <Link
              href="https://play.google.com/store/apps/details?id=com.ublendreact&amp;hl=en"
              target="_blank"
              rel="noreferrer"
            >
              Android app
            </Link>
          </FooterLinks>
        </div>
        <div>
          <FooterLinks>
            <FooterHeading>
              <span>Company</span>
            </FooterHeading>
            <Link
              href="https://aulaeducation.recruitee.com/"
              target="_blank"
              rel="noreferrer"
            >
              Careers - join us!
            </Link>
            <Link
              href="https://www.notion.so/The-Aula-Brain-4da091a8797840108311d99815b3b36f"
              target="_blank"
              rel="noreferrer"
            >
              The Aula Brain
            </Link>
            <Link
              target="_blank"
              rel="noreferrer"
              href="https://blog.aula.education/"
            >
              Blog
            </Link>
          </FooterLinks>
        </div>
        <div>
          <FooterLinks>
            <FooterHeading>
              <span>SUPPORT</span>
            </FooterHeading>
            <Link
              href="https://general.aula.education/#/"
              target="_blank"
              rel="noreferrer"
            >
              Sign in
            </Link>
            <Link
              href="https://aula.zendesk.com/hc/en-us"
              target="_blank"
              rel="noreferrer"
            >
              Help centre
            </Link>
            <Link
              href="https://aula.zendesk.com/hc/en-us/requests/new"
              target="_blank"
              rel="noreferrer"
            >
              Contact support
            </Link>
          </FooterLinks>
        </div>
      </FooterGrid>
      <Divider />
      <CopyrightContainer>
        <CopyrightLinksContainer>
          <CopyRightLink
            href="https://aula.zendesk.com/hc/en-us/articles/360017891999-Aula-Accessibility-Statement-September-2020"
            target="_blank"
            rel="noreferrer"
          >
            Accessibility Statement
          </CopyRightLink>{' '}
          |{' '}
          <CopyRightLink
            href="https://www.aula.education/privacy"
            target="_blank"
            rel="noreferrer"
          >
            Privacy Policy
          </CopyRightLink>{' '}
          |{' '}
          <CopyRightLink
            href="https://www.aula.education/terms-of-service"
            target="_blank"
            rel="noreferrer"
          >
            Terms of Service
          </CopyRightLink>{' '}
          |{' '}
          <CopyRightLink
            href="https://www.coventry.ac.uk/the-university/financial-information/procurement/modern-slavery-statement/"
            target="_blank"
            rel="noreferrer"
          >
            Modern Slavery Act Transparency Statement
          </CopyRightLink>
        </CopyrightLinksContainer>
        <CompanyName>© Aula Education Ltd., 2021</CompanyName>
      </CopyrightContainer>
    </FooterContainer>
  </Container>
);
